/**
 * created by wang lei
 资源库文件继承 页面
 *
 */
import React, {Component} from 'react';
import ComponentsList from "../../../resource/components/ComponentsList";

export default class resourceFileExtends extends ComponentsList {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
            </div>
        )
    }

}